import React from 'react';
import { FaReact } from "react-icons/fa";
import { FaNodeJs } from "react-icons/fa";
import { MdOutlineSecurity } from "react-icons/md";

const services = [
  {
     icon: <FaReact />,
    title: "Frontend Development",
    description: "Building responsive, accessible user interfaces with React. We focus on performance optimization, state management, and seamless user experiences.",
    tags: ["React", "Next.js", "TypeScript"]
  },
  {
    icon: <FaNodeJs />,
    title: "Backend Development",
    description: "Scalable server-side solutions with Node.js and Python. We implement RESTful APIs, GraphQL, and microservices architectures for your business logic.",
    tags: ["Node.js", "Python", "PostgreSQL"]
  },
  {
    icon: <MdOutlineSecurity />,
    title: "DevOps & Security",
    description: "Secure deployment pipelines and infrastructure management. We implement CI/CD, monitoring, and security best practices for your applications.",
    tags: ["Docker", "AWS", "Security"]
  }
];

const Services = () => {
  return (
    <section className="featured-section" id="services">
      <div className="page-title in-view">
        <h3>Professional Services</h3>
      </div>
      <div className="services__grid">
        {services.map((service, index) => (
          <div className="service-card fade-in" key={index}>
            <div className="service-card__icon">{service.icon}</div>
            <h3 className="service-card__title">{service.title}</h3>
            <p className="service-card__description">{service.description}</p>
            <div className="project-card__tech">
              {service.tags.map(tag => (
                <span className="tech-tag" key={tag}>{tag}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;